import { GET, UPDATE } from "../components/constants/request-type";
import { service_api } from "../components/constants/url";
import { MakeRequestAsync } from "../components/functions/axios";
import { createLogger } from "../utils/logger";

const logger = createLogger("LanguageService");
// Get user language preference
export const getUserLanguage = async (userId, token) => {
  const request_details = {
    type: GET,
    url: service_api,
    route: `user/language/${userId}`,
    data: null,
    token: token
  };

  try {
    const response = await MakeRequestAsync(request_details);
    return response.data;
  } catch (error) {
    logger.error("Error fetching user language:", error);
    throw error;
  }
};

// Update user language preference
export const updateUserLanguage = async (userId, language, token) => {
  const request_details = {
    type: UPDATE,
    url: service_api,
    route: `user/language/${userId}`,
    data: { language },
    token: token
  };

  try {
    const response = await MakeRequestAsync(request_details);
    return response.data;
  } catch (error) {
    logger.error("Error updating user language:", error);
    throw error;
  }
};
